import styled from '@emotion/styled';

export const Wrapper = styled.button`
  position: absolute;
  right: -8px;
  top: -2px;
`;
